import React from "react";

// Chakra imports
import {
  Icon,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdOutlineMoreHoriz } from "react-icons/md";

export default function Banner({ items = [], ...rest }) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textHover = useColorModeValue(
    { color: "secondaryGray.900", bg: "white" },
    { color: "secondaryGray.500", bg: "whiteAlpha.100" }
  );
  const iconColor = useColorModeValue("brand.500", "white");
  const bgList = useColorModeValue("brand.100", "whiteAlpha.100");
  const bgShadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Menu isOpen={isOpen} onClose={onClose}>
      <MenuButton
        align='center'
        justifyContent='center'
        bg={bgButton}
        _hover={bgHover}
        _focus={bgFocus}
        _active={bgFocus}
        w='37px'
        h='37px'
        lineHeight='100%'
        onClick={onOpen}
        borderRadius='10px'
        {...rest}
      >
        <Icon as={MdOutlineMoreHoriz} color={iconColor} w='24px' h='24px' />
      </MenuButton>
      <MenuList
        w='150px'
        minW='unset'
        maxW='150px !important'
        border='transparent'
        backdropFilter='blur(63px)'
        bg={bgList}
        boxShadow={bgShadow}
        borderRadius='20px'
        p='10px'
      >
        {items.map((item, idx) => (
          <MenuItem
            key={idx}
            transition="0.2s linear"
            p="6px"
            mb="4px"
            _last={{ mb: "0px" }}
            borderRadius="8px"
            color={textColor}
            bg={bgList}
            _hover={textHover}
            _focus={textHover}
            _active={textHover}
            onClick={item.onClick}
          >
            <Flex align="center">
              <Text fontSize="sm" fontWeight="400" me="2">{item.icon}</Text>
              <Text fontSize="sm" fontWeight="400">
                {item.label}
              </Text>
            </Flex>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
